import { gql } from '@apollo/client';
import { DealFragment } from '../fragments/DealFragment';
/**
 * Public API deal query (no internalNotes field).
 * @const DealPublicQuery
 * @since 1.0.0
 */
export const DealPublicQuery = gql `
  query DealPublicQuery($input: DealInput!) {
    deal(input: $input) {
      ...DealFragment
      items {
        id
        options {
          id
          quantityEditable
        }
      }
    }
  }

  ${DealFragment}
`;
